import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  GetAuditDocumentParams,
  GetAuditDocumentResponse,
  PostAuditDocumentMarkAsReadParams,
  PostAuditDocumentMarkAsReadResponse,
} from "./types";
import {
  DeleteAuditDocumentParams,
  DeleteAuditDocumentResponse,
} from "./types";
import { List } from "api/slice/types";

export const AuditDocumentsAPI = {
  getAuditDocument: async (
    params: GetAuditDocumentParams
  ): Promise<List<GetAuditDocumentResponse>> => {
    const response = await axiosApi.get<List<GetAuditDocumentResponse>>(
      "/documents/audit-document",
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  deleteAuditDocument: async (
    params: DeleteAuditDocumentParams
  ): Promise<DeleteAuditDocumentResponse> => {
    const response = await axiosApi.delete<DeleteAuditDocumentResponse>(
      `/documents/audit-document`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postAuditDocumentMarkAsRead: async ({
    id,
    ...params
  }: PostAuditDocumentMarkAsReadParams): Promise<PostAuditDocumentMarkAsReadResponse> => {
    const response = await axiosApi.post<PostAuditDocumentMarkAsReadResponse>(
      `/documents/audit-document/${id}/mark-as-read`,
      params,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
};
